import React, {useState} from 'react';

import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {contentIcAdd24px, contentIcRemove24px} from '@ey/motif-react-wrapper/assets/icons';

import StyledTeamAccordion from './StyledTeamAccordion';

const TeamAccordion = ({children, header}) => {
	const [open, setOpen] = useState(true);

	const renderTrigger = () => {
		const icons = {
			true: contentIcRemove24px,
			false: contentIcAdd24px
		};

		return <MotifIcon src={icons[open]} onClick={() => setOpen(!open)} />;
	};

	const props = {
		open
	};

	return (
		<StyledTeamAccordion {...props}>
			<div className="team-accordion-header">
				{children !== null && renderTrigger()}
				{header}
			</div>
			<div className="team-accordion-content">{children !== null && children}</div>
		</StyledTeamAccordion>
	);
};

export default TeamAccordion;
